import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Connect"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.2503 12.0075C16.1203 12.0086 15.0209 12.3742 14.1153 13.05L10.9503 9.88504C11.6341 8.98606 12.0031 7.88703 12.0003 6.75754C12.0064 4.32237 10.3371 2.20266 7.96836 1.63767C5.59962 1.07268 3.15331 2.21073 2.05959 4.38648C0.965878 6.56223 1.5119 9.20448 3.37845 10.7685C5.24499 12.3325 7.94202 12.4077 9.89277 10.95L13.0503 14.115C11.5931 16.0652 11.6677 18.7614 13.2306 20.6279C14.7935 22.4945 17.4346 23.0418 19.6105 21.9499C21.7864 20.8581 22.9262 18.4136 22.3639 16.045C21.8016 13.6763 19.6848 12.0049 17.2503 12.0075ZM3.00036 6.75754C3.00036 4.68647 4.6793 3.00754 6.75036 3.00754C8.82143 3.00754 10.5004 4.68647 10.5004 6.75754C10.5004 8.82861 8.82143 10.5075 6.75036 10.5075C4.6793 10.5075 3.00036 8.82861 3.00036 6.75754Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Connect.vue"]]);
